import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { IonicModule } from '@ionic/angular';
import { PipeModule } from 'src/app/pipe/pipe/pipe.module';
import { CadAlertComponent } from './cad-alert.component';

@NgModule({  
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PipeModule,
    ReactiveFormsModule,    
    MatDialogModule,
  ],
  declarations: [CadAlertComponent],
  exports: [
    CadAlertComponent
  ]
})
export class CadAlertModule {}
